module.exports = __webpack_public_path__ + "assets/img/AIF-Australian-Institute-of-Fitness-Page-Resource.9f6f22de.jpg";